export enum ContentType {
    Webtoon = 0, // 웹툰
    Video = 1, // 영상
    Tutorial = 2, // 튜토리얼
}

export enum OrderType {
    Asc = 0,
    Desc = 1,
}
